import { supabase } from "@/lib/supabase-client";
import { TenantType } from "@/types/db/tenants";

export const tenantService = {
  async getTenantMetaData(): Promise<TenantType["meta_data"] | null> {
    const { data, error } = await supabase.from("tenants").select("meta_data").single();

    if (error) {
      throw new Error(error.message);
    }

    return (data as any)?.meta_data ?? null;
  },

  async getTenantNameAndMeta(): Promise<{ name: string; meta_data: TenantType["meta_data"] } | null> {
    const { data, error } = await supabase.from("tenants").select("name, meta_data").single();
    if (error) {
      throw new Error(error.message);
    }
    return data as any;
  },

  async updateTenantMetaData(tenantId: string, meta_data: TenantType["meta_data"]): Promise<TenantType["meta_data"]> {
    const { data, error } = await supabase
      .from("tenants")
      .update({ meta_data })
      .eq("id", tenantId)
      .select("meta_data")
      .single();

    if (error) {
      throw new Error(error.message);
    }

    return (data as any)?.meta_data ?? null;
  },
};
